import React, {useEffect, useState} from 'react'
import DQRatingContentReportView from "../../../views/ver_24.10/ProgramRating/DQRating/DQRatingContentReport.view";
import {useHistory, useParams} from "react-router-dom";
import {useAuth} from "../../../context/auth";
import {downloadBadgeService, fetchRatingProgramStatusService} from "../../../services/rating.service";
import Loader from "../../../ui_library/ver_24.10/Loader/Loader.comp";
import {APP_STATUS, LOCAL_STORAGE_KEYS, TOAST_TYPES} from "../../../utils/constants";
import {toast} from "../../../utils/utils";

const DQRatingContentReport = () => {
    const { programId } = useParams();
    const history = useHistory();
    const { authUser } = useAuth();
    const [showLoader, setShowLoader] = useState(false);
    const [programStatus, setProgramStatus] = useState(null);
    const [programStatusV3, setProgramStatusV3] = useState(null);
    const [programPaymentStatus, setProgramPaymentStatus] = useState(null);

    const programInfo = [
        { title: "Type:", value: "Learning Program" },
        { title: "Total Learning Time:", value: "8 Hours" },
        { title: "Country:", value: "Singapore" },
        { title: "Audience:", value: "Secondary Students" },
    ];

    useEffect(() => {
        setShowLoader(true);

        const fetchProgramData = async () => {
            try {
                await fetchRatingProgram();
            } catch (error) {
                // Handle error if needed
                console.error('Error fetching program:', error);
            } finally {
                setShowLoader(false);
            }
        };

        fetchProgramData().then(r => console.log(r));
    }, [programId]);

    const fetchRatingProgram = async () => {
        const result = await fetchRatingProgramStatusService(programId);
        if (result.data) {
            setProgramStatus(result.data.app_status);
            setProgramStatusV3(result.data.app_status_v3);
            setProgramPaymentStatus(result.data.payment_status_v3)
            if (
                result.data.app_status_v3 < APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED
            ) {
                history.push(`/dq_rating/${programId}`);
            }
        }
    };

    const data = {
        programInfo,
        programStatus,
        programStatusV3,
        programPaymentStatus,
    };

    // Actions handling business logic
    const actions = {
        showPdfReportAction: async () => {
            if (programId && programPaymentStatus === APP_STATUS.COMPLETED && programStatusV3 >= APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED ) {
                history.push(`/dq_rating/${programId}/full_report`);
            } else {
                history.push(`/dq_rating/${programId}/payment`);
            }
        },
        signUpAction: (redirect_to_url) => {
            if (redirect_to_url) {
                localStorage.setItem(LOCAL_STORAGE_KEYS.redirect_to_url, redirect_to_url);
            } else {
                localStorage.setItem(LOCAL_STORAGE_KEYS.redirect_to_url, `/dq_rating/${programId}/payment`);
            }
            history.push(`/auth/persist_guest_account`);
        },
        downloadBadgeAction: async () => {
            try {
                setShowLoader(true);
                const result = await downloadBadgeService();
                if (!result.error && result.data) {
                    toast(TOAST_TYPES.SUCCESS, "Email Sent", "Successfully Badge sent to the Email Address");
                }
            } catch (e) {
                // already toasted the error
                setShowLoader(false);
            } finally {
                setShowLoader(false);
            }
        },
        accessAssessmentAction: (program_status) => {
            if (program_status === APP_STATUS.ASSESSMENTS_READY) {
                history.push(`/rating/${programId}/access_assessment`);
            } else {
                history.push(`/rating/${programId}/select_assessment`);
            }
        },
    };

    // Configuration options for visual appearance
    const options = {
        isGuestUser: authUser.is_guest,
        programId,
    };

    if (showLoader) {
        return <Loader />;
    }

    return (
        <>
            <DQRatingContentReportView
                data={data}
                actions={actions}
                options={options}
            />
        </>
    );
}

export default DQRatingContentReport;